<template>
  <div v-show="$store.state.isLoading == false && showformular" class="usereditnew formular">

    <div class="form-container">
        <p>Benutzerdaten</p>
        <ul class="flex-outer">
          <li :class="validation.loginname.class">
            <label for="loginname">Benutzername:</label>
            <input type="text" tabindex="1" id="loginname" ref="loginname" spellcheck="false" v-model="currentUser.loginname" autocomplete="new-password">
          </li>
        </ul>

        <div v-show="currentUser.passwordStatus == 1" class="generate_password">
          <button v-if="$route.params.user_id > 0" tabindex="2" class="btn bt_generate_password" v-on:click="btChangeToPasswortDontChange" title="Passwort nicht ändern"><i class="close icon"></i></button>
          <button v-else tabindex="2" class="btn bt_dont_change_password" v-on:click="btChangeToPasswortEnter" title="Passwort selbst vergeben"><i class="edit icon"></i></button>
          <ul class="flex-outer">
          <li>
            <label>Passwort:</label>
            <div><input type="text" tabindex="3" class="disabledCenter" id="generate_password" ref="generate_password" spellcheck="false" value="WIRD GENERIERT" readonly></div>
          </li>
          </ul>
        </div>

        <div v-show="currentUser.passwordStatus == 0" class="dont_change_password">
          <button tabindex="4" class="btn bt_dont_change_password" v-on:click="btChangeToPasswortEnter" title="Passwort selbst vergeben"><i class="edit icon"></i></button>
          <ul class="flex-outer">
          <li>
            <label>Passwort:</label>
            <div><input type="text" tabindex="5" class="disabledCenter" id="dont_change_password" ref="dont_change_password" spellcheck="false" value="WIRD NICHT GEÄNDERT" readonly></div>
          </li>
          </ul>
        </div>

        <div v-show="currentUser.passwordStatus == 2" class="enter_password">
          <button tabindex="6" class="btn bt_change_to_password_generate" v-on:click="btChangeToPasswordGenerate" title="Passwort wird generiert"><i class="magic icon"></i></button>
        <ul class="flex-outer">
          <li :class="validation.password.class">
            <label for="password">Passwort:</label>
            <div><input type="password" tabindex="7" id="password" ref="password" spellcheck="false" v-model="currentUser.password" autocomplete="new-password"></div>
          </li>
          <li :class="validation.password.class">
            <label for="password_wdh">Passwort (Wdh.):</label>
            <div><input type="password" tabindex="8" id="password_wdh" ref="password_wdh" spellcheck="false" v-model="currentUser.password_wdh" autocomplete="new-password"></div>
          </li>
          </ul>
        </div>

        <ul class="flex-outer">
          <li :class="validation.email.class">
            <label for="email">E-Mail Adresse:</label>
            <input type="email" tabindex="9" id="email" ref="email" spellcheck="false" v-model="currentUser.email">
          </li>
          <li :class="validation.security_group.class">
            <label for="security_group">Benutzergruppe:</label>
            <sui-dropdown
                  :options="optionsSecurity"
                  placeholder="- Bitte auswählen -"
                  search
                  selection
                  tabindex="10"
                  :loading="loadSecurity"
                  v-model="currentUser.security_group"
                  noResultsMessage="Kein Ergebnis gefunden"
                />
          </li>
        </ul>
    </div>

    <div class="form-container">
        <p>Persönliche Daten</p>
        <ul class="flex-outer">
          <li>
            <label for="prename">Vorname:</label>
            <input type="text" tabindex="11" :class="prenameFamilynameClass" id="prename" ref="prename" spellcheck="false" v-model="prename" :readonly="Checkreadonly">
          </li>
          <li>
            <label for="familyname">Nachname:</label>
            <input type="text" tabindex="12" :class="prenameFamilynameClass" id="familyname" ref="familyname" spellcheck="false" v-model="familyname" :readonly="Checkreadonly">
          </li>
          <li>
            <label for="memberSelected">Mitglied:</label>
                <sui-dropdown
                  :options="optionsMember"
                  placeholder="- Bitte auswählen -"
                  search
                  selection
                  tabindex="13"
                  :loading="loadMember"
                  v-model="currentUser.member_id"
                  noResultsMessage="Kein Ergebnis gefunden"
                />
            </li>
        </ul>
    </div>

    <div class="form-container">
      <ul class="flex-outer">
        <li>
      <button tabindex="15" class="btn editadd" v-on:click="editadd">SPEICHERN</button>
      </li>
        </ul>
    </div>
  </div>
</template>

<script>
import EventBus from "../bus";
import functions from '../mixins/functions';
import validation from '../mixins/validation';

export default {
  name: 'usereditnew',
  mixins: [functions, validation],
  props: {
      member: {
          type: Object,
          default: () => ({}),
      },
  },
  data () {
    return {
      optionsMember: [],
      selectedMember: 0,
      loadMember: true,
      optionsSecurity: [],
      selectedSecurity: 0,
      loadSecurity: true, // 0 = wird nicht geändert / 1 = wird generiert / 2 = wird eingegeben
      currentUser: { user_id: 0, 
                     member_id: 0, 
                     security_group: 0, 
                     passwordStatus: 0, 
                     loginname: '', 
                     email: '', 
                     userprename: '', 
                     prename : '',  
                     userfamilyname: '', 
                     familyname : '' 
                   },
      validation: {
        loginname: { type: 'minLength[3]', prompt: 'Benutzername muss mindestens 3 Zeichen lang sein' },
        email: { type: 'email', prompt: 'E-Mail Adresse ist keine gültige E-Mail', promptEmpty: 'E-Mail Adresse ist ein Pflichtfeld' },
        password: { type: 'minLength[6]password', compareField: 'password_wdh', prompt: 'Passwort muss mindestens 6 Zeichen lang sein', prompt2: 'Eingebene Passwörter stimmen nicht überein' },
        security_group: { type: 'selectionNot0', prompt: 'Auswahl Benutzergruppe fehlt' }
      },
      users: [],
      showformular: true
    }
  },
  computed:{
    prename:{
      get: function(){
        if(this.currentUser.member_id > 0){
          return this.optionsMember.find( x => x.value === this.currentUser.member_id).prename
        }
        else{
          return this.currentUser.userprename
        }
      },
      set: function(value){
        this.currentUser.prename = value
        this.currentUser.userprename = value
      }      
    },
    familyname:{
      get: function(){
        if(this.currentUser.member_id > 0){
          return this.optionsMember.find( x => x.value === this.currentUser.member_id).familyname
        }
        else{
          return this.currentUser.userfamilyname
        }
      },
      set: function(value){
        this.currentUser.familyname = value
        this.currentUser.userfamilyname = value
      } 
      
    },
    prenameFamilynameClass(){
      return (this.currentUser.member_id > 0) ? "disabled" : ""
    },
    Checkreadonly(){
      return (this.currentUser.member_id > 0) ? true : false
    }
    
  },
  created: function (){
    this.resetBar();
    if(this.$store.state.user.permissions.user_add){
      this.$store.state.bar.add = true
    }
  },
  mounted: function () {
    this.infoShow = false
    this.resetValues()
    this.loadInit()

    EventBus.$on("add", (item) => {
      this.resetValues()
      this.currentUser.passwordStatus = 1
      this.$router.push({ name: 'newUser' }).catch(err => {});
      this.$nextTick(() => this.$refs.loginname.select())
    });
    
  },
  methods:{
    resetValues: function(){
      this.currentUser = { user_id: 0, 
                           member_id: 0, 
                           security_group: 0, 
                           passwordStatus: 0, 
                           loginname: '', 
                           email: '', 
                           userprename: '', 
                           prename : '',  
                           userfamilyname: '', 
                           familyname : '' 
                         }
    },
    loadInit: function(){
      EventBus.$emit("checklogin")
      console.log(this.$store.state.user.permissions.user_add)
      console.log(this.$store.state.user.permissions.user_change)
      console.log(this.$route.params.user_id)
      if(typeof this.$route.params.user_id == 'undefined' && this.$store.state.user.permissions.user_add == 0){
        this.showformular = false
        EventBus.$emit("showinfo", "error", "Keine Berechtigung Benutzer anzulegen", 15)
        return
      }
      if(this.$route.params.user_id > 0 && this.$store.state.user.permissions.user_change == 0){
        this.showformular = false
        EventBus.$emit("showinfo", "error", "Keine Berechtigung Benutzer zu ändern", 15)
        return
      }

      this.$http.get('/api/getData.pl', {params:  {data: ['select_member','select_security', 'users']}}).then(function (response) {
        this.optionsMember = response.data.select_member
        this.loadMember = false
        this.optionsSecurity = response.data.select_security
        this.loadSecurity = false
        this.users = response.data.users
      });

      if(this.$route.params.user_id > 0){
        this.$store.state.heading = "Benutzer editieren"
        this.$store.state.isLoading = true
        this.$http.get('/api/get_user.pl', {params:  {user_id: this.$route.params.user_id}}).then(function (response) {
            this.currentUser = response.data.users
            this.$store.state.isLoading = false
            if( this.currentUser == 0 ){
              this.showformular = false
              EventBus.$emit("showinfo", "error", "Der Benutzer mit der ID " + this.$route.params.user_id + " existiert nicht", 0)  
            }
            else{
              response.data.dberror ? EventBus.$emit("showinfo", "error", response.data.dberror.errorText, 15) : undefined
              this.validationCheck(this.validation, this.currentUser)
            }
          });
      }
      else{
        this.currentUser.passwordStatus = 1 // 0 = wird nicht geändert / 1 = wird generiert / 2 = wird eingegeben
        this.$store.state.heading = "Benutzer hinzufügen"
        this.validationCheck(this.validation, this.currentUser)
      }
      
      if(typeof this.$refs.loginname != 'undefined' ){
        this.$nextTick(() => this.$refs.loginname.select())
      }
      
    },
    editadd: function (event) {
      this.validation.password.activ = (this.currentUser.passwordStatus <= 1) ? false : true

      // trim alle Strings in dem object currentUser
      Object.keys(this.currentUser).map(k => this.currentUser[k] = typeof this.currentUser[k] == 'string' ? this.currentUser[k].trim() : this.currentUser[k]);

      var FormErrors = [] //this.validationCheck(this.validation, this.currentUser)
      FormErrors.length > 0 ? EventBus.$emit("showinfo", "error", FormErrors, 3) : undefined
      if(FormErrors.length == 0){
        if(this.users.find(x => x.value != this.currentUser.user_id && x.text.toUpperCase() === this.currentUser.loginname.toUpperCase())){
          EventBus.$emit("showinfo", "error", "Der Benutzername '" + this.currentUser.loginname + "' existiert schon, bitte einen anderen Benutzernamen eingeben.", 10)
        }
        else if(this.users.find(x => x.value != this.currentUser.user_id && x.email.toUpperCase() === this.currentUser.email.toUpperCase())){
          EventBus.$emit("showinfo", "error", "Die E-Mail Adresse '" + this.currentUser.email + "' gehört schon zu einem anderen Benutzer. Bitte eine andere E-Mail eingeben.", 10)
        }
        else{ 
          let headers = {'Content-Type': 'application/json'};
          this.$http.post('/api/set_user.pl', {user: this.currentUser}, {headers}).then(function (response) {
            var result = response.data
            if( result.status == 0 ){
              EventBus.$emit("showinfo", "error", result.error, 10)  
            }
            else if( result.status == 2 ){
              EventBus.$emit("showinfo", "info", result.info, 5)   
            }
            else{
              if( result.newuserid > 0 ){
                this.resetValues()
                this.loadInit()
                //this.$router.push({ name: 'editUser', params: { user_id: result.newuserid } })
              }
              EventBus.$emit("showinfo", "success", result.info, 10) 
            }
          });
        }
      }
    },
    btChangeToPasswordGenerate: function (event){
      this.currentUser.passwordStatus = 1
    },
    btChangeToPasswortEnter: function (event){
      this.currentUser.passwordStatus = 2
    },
    btChangeToPasswortDontChange: function (event){
      if(this.$route.params.user_id > 0){
        this.currentUser.passwordStatus = 0 
      }
    }
  },
  watch: {
    currentUser: {
      handler(val, oldVal){
        var resultErrors = this.validationCheck(this.validation, val)
      },
      deep: true
    },
    '$route' (to, from){
      this.resetValues()
      this.loadInit()
    }
  },
  components: {
  }
}
</script>

<style scoped>
.enter_password, .dont_change_password, .generate_password{
  position: relative;
}
.enter_password input, .dont_change_password input, .generate_password input{
  /* margin-right: 27px; */
  width: 81%;
}
input.disabledCenter{
  text-align: center;
}

.bt_change_to_password_generate, .bt_dont_change_password, .bt_generate_password {
  position: absolute;
  width: 9%;
  height: 79px;
  right: 10px;
  top: 2px;
  display: flex;
  justify-content: center;
  align-items: center; 
}
.bt_dont_change_password, .bt_generate_password{
  height: 32px;
}
.icon{
  padding: 0 4px 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/UserEditNew.vue